import angular from "angular"

FormularioEliminarRolesController.$inject = ["$scope", "$mdDialog", "saveCallback"]
function FormularioEliminarRolesController($scope, $mdDialog, saveCallback) {
  var self = $scope

  self.eliminar = function() {
    saveCallback()
    self.cancelar()
  }

  self.cancelar = function() {
    $mdDialog.hide()
  }
}

angular
  .module("appModule")
  .controller("FormularioEliminarRolesController", FormularioEliminarRolesController)
